var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2Update(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.41 39.09c-.13-14.57-11.56-26.37-25.59-26.37a25.3 25.3 0 00-21.4 12l3.69 2.33a21.001 21.001 0 0117.71-10c11.63 0 21.09 9.85 21.23 22H53l8 8.81 8.47-8.81-6.06.04zm-50.82-2.18c.13 14.57 11.56 26.37 25.59 26.37a25.3 25.3 0 0021.4-12l-3.69-2.33a21.001 21.001 0 01-17.71 10c-11.63 0-21.09-9.85-21.23-22H23l-8-8.81-8.47 8.81 6.06-.04z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Update.ce8814b8.svg";
export { SvgJ2Update as ReactComponent };